export interface ISelectedCenterOrgan {
    centerId: number;
    organType: number | null;
}